import script from "./AIAssistantFormTemplateSelectionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIAssistantFormTemplateSelectionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AIAssistantFormTemplateSelectionModal.vue?vue&type=style&index=0&id=237c24b2&scoped=true&lang=scss"
import "./AIAssistantFormTemplateSelectionModal.vue?vue&type=style&index=1&id=237c24b2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-237c24b2"]])

export default __exports__